module.exports = __webpack_public_path__ + "static/media/hero-bedroom.474b1a16.jpg";